import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, Stack, TextField } from "@mui/material";
import { cloneDeep, debounce, isArray } from "lodash";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from "../../../../../redux/slices/treeSlice";

function NumericRangeType() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const rightTree = useSelector((state) => state.treeData[parentScreen].rightTree);
  const currentTab = rightTree.currentTab;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const translatedData = rightTree.tree[currentTab].translatedData;

  const [minRange, setMinRange] = useState("");
  const [maxRange, setMaxRange] = useState("");
  const [minRangeError, setMinRangeError] = useState(false);
  const [maxRangeError, setMaxRangeError] = useState(false);
  
  const validateInput = (value) => {
    const maxLength = 9;
    const regex = /^(\d+(\.\d*)?|\.\d+)$/;
    
    if (value === "") {
      return { isValid: true };
    }
    if (value.length > maxLength) {
      return { isValid: false, message: 'Field should be less than 10 numeric characters' };
    }
    if (!regex.test(value)) {
      return { isValid: false, message: t("VALIDATE_ONLY_NUMERIC_ALLOWED") };
    }
    return { isValid: true };
  };
  

  const handleRangeChange = (type, value) => {
    const validation = validateInput(value);
    if (type === "RANGE_MIN") {
      setMinRange(value);
      setMinRangeError(!validation.isValid ? validation.message : "");
    } else if (type === "RANGE_MAX") {
      setMaxRange(value);
      setMaxRangeError(!validation.isValid ? validation.message : "");
    }
    
    if (validation.isValid) {
      debounceChangeHandler(type, value);
    }
  };

  const checkMinMaxState = (e) => {
    const { value,name } = e.target
    if(!value){
      name === 'RANGE_MIN' ? setMinRange('0.0') : setMaxRange('0.0')
      debounceChangeHandler(name,"0.0");
      return;
    }
    let reduxData = {};
    const validation = validateInput(minRange);

    if ((Number(maxRange) <= Number(minRange)) && validation.isValid) {
      reduxData = { RANGE_MIN: minRange, RANGE_MAX: minRange };
      setMaxRange(minRange);
    }
    if (validation.isValid) {
      debounceChangeHandler(null, null, reduxData);
    }
  };

  const submitChange = (key, value, valuesObj) => {
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if (obj?.key !== selectedNode?.key) {
        return;
      }
      if (value) {
        obj[key] = value;
      }   else {
        for (let key in valuesObj) {
          obj[key] = valuesObj[key];
        }
      }
      if (isArray(obj?.children)) {
        return obj.children;
      }
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: obj,
        })
      );

     
    });

    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: currentTab,
        data: updatedData,
      })
    );
  };

  const debounceChangeHandler = debounce(submitChange, 200);
  
  useEffect(() => {
    if (selectedNode) {
      setMinRange(selectedNode.RANGE_MIN?.trim() || "0.0");
      setMaxRange(selectedNode.RANGE_MAX?.trim() || "0.0");
    }
  }, [selectedNode?.key]);
  

  return (
    <>
      <FormControl className="width-100" size="small">
        <Stack spacing={"10px"} className="tp-segment">
          <div className="flex">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_RANGE_MIN")}
              className={"width-100"}
              type="text"
              value={minRange}
              name="RANGE_MIN"
              onChange={(e) => handleRangeChange("RANGE_MIN", e.target.value)}
              onBlur={checkMinMaxState}
              helperText={minRangeError}
              error={!!minRangeError}
            />
          </div>
        </Stack>
        <div className="flex">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_RANGE_MAX")}
            className={"width-100"}
            type="text"
            value={maxRange}
            name="RANGE_MAX"
            onChange={(e) => handleRangeChange("RANGE_MAX", e.target.value)}
            onBlur={checkMinMaxState}
            helperText={maxRangeError}
            error={!!maxRangeError}
          />
        </div>
      </FormControl>
    </>
  );
}

export default NumericRangeType;
